/**
 * Composant GlobalRating pour la page Satisfaction
 * Affiche la moyenne globale + moyenne par type de questionnaire
 */

import { Card, CardContent } from '../../components/ui/card';
import { Star } from 'lucide-react';

export const renderStars = (note) => {
  const rounded = Math.round(note || 0);
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map(i => (
        <Star 
          key={i} 
          className={`h-4 w-4 ${i <= rounded ? 'text-amber-400 fill-amber-400' : 'text-slate-200'}`} 
        />
      ))}
      <span className="ml-2 text-sm font-medium">{note}/5</span>
    </div>
  );
};

export const GlobalRating = ({ moyenneGlobale, reponses, centreFilter, moyennesParType, types }) => {
  return (
    <Card className="bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200" data-testid="global-rating">
      <CardContent className="p-4">
        {/* Ligne 1 : Moyenne globale */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-amber-100 rounded-full">
              <Star className="h-8 w-8 text-amber-600 fill-amber-600" />
            </div>
            <div>
              <p className="text-sm text-amber-700 font-medium">Moyenne globale de satisfaction</p>
              <div className="flex items-center gap-2">
                <span className="text-3xl font-bold text-amber-700">{moyenneGlobale || '-'}</span>
                <span className="text-lg text-amber-600">/5</span>
                {moyenneGlobale && renderStars(Math.round(moyenneGlobale))}
              </div>
            </div>
          </div>
          <div className="text-right text-sm text-amber-600">
            <p>{reponses?.length || 0} réponses analysées</p>
            <p className="text-xs">
              {centreFilter === 'all' ? 'Tous centres confondus' : 
               centreFilter === 'atlantique' ? 'Centre Atlantique' : 'Centre Occitanie'}
            </p>
          </div>
        </div>

        {/* Ligne 2 : Moyennes par type de questionnaire */}
        {moyennesParType && Object.keys(moyennesParType).length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 pt-3 border-t border-amber-200">
            {Object.entries(moyennesParType).map(([qtype, data]) => (
              <div key={qtype} className="bg-white/70 rounded-lg p-2.5 text-center border border-amber-100">
                <p className="text-xs text-slate-600 font-medium mb-1 truncate" title={types?.[qtype]?.label || qtype}>
                  {types?.[qtype]?.label || qtype}
                </p>
                <div className="flex items-center justify-center gap-1">
                  <Star className="h-3.5 w-3.5 text-amber-400 fill-amber-400" />
                  <span className="text-lg font-bold text-amber-700">{data.moyenne_globale}</span>
                  <span className="text-xs text-amber-500">/5</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default GlobalRating;
